import { FC } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { ConnectedRouter } from 'connected-react-router';
import { BrowserRouter } from 'react-router-dom';
import i18next from 'i18next';

import reportWebVitals from './reportWebVitals';
import Layout from './components/LayoutComponents';
import history from './routers/history';
import { store } from './redux/store';

import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

import './resources/_antd.less'; // redefinition AntDesign variables
import './styles/common.scss';
import './styles/global.scss';
import './styles/icon-config.scss';
import './styles/icon.css';

import { resources } from './commons/constants';
import vi from './translations/vi-VN.json';
import en from './translations/en-US.json';

i18next.init({
  interpolation: { escapeValue: false }, // React already does escaping
  lng: resources['vi-VN'].key, // language to use
  resources: {
    [resources['vi-VN'].key]: {
      translation: vi,
    },
    [resources['en-US'].key]: {
      translation: en,
    },
  },
});

const App: FC = () => (
  <BrowserRouter>
    <HelmetProvider>
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <Helmet titleTemplate="Clik Inventory | %s" />
          <Layout />
        </ConnectedRouter>
      </Provider>
    </HelmetProvider>
  </BrowserRouter>
);

ReactDOM.render(<App />, document.getElementById('root'));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
